<!--vex-secondary-toolbar current="Dashboards">
  <vex-breadcrumbs
    [crumbs]="['Dashboards', 'Analytics']"
    class="flex-auto"></vex-breadcrumbs>

  <button class="ml-2" color="primary" mat-icon-button type="button">
    <mat-icon svgIcon="mat:more_vert"></mat-icon>
  </button>
</vex-secondary-toolbar-->

<div class="container p-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
  <vex-widget-assistant class="sm:col-span-2"></vex-widget-assistant>

  <vex-widget-quick-line-chart
    [series]="pageViewsSeries"
    icon="mat:pageview"
    iconClass="text-primary-600 bg-primary-600/10"
    label="Page Views"
    value="92.4k"></vex-widget-quick-line-chart>

  <vex-widget-quick-line-chart
    [options]="uniqueUsersOptions"
    [series]="uniqueUsersSeries"
    icon="mat:group"
    iconClass="text-orange-600 bg-orange-600/10"
    label="Unique Users"
    value="67.2k"></vex-widget-quick-line-chart>

  <vex-widget-large-goal-chart
    [series]="salesSeries"
    class="sm:col-span-full"
    total="4,374"></vex-widget-large-goal-chart>

  <vex-widget-quick-value-center
    [change]="124.4"
    icon="mat:group"
    iconClass="text-primary-600 bg-primary-600/10"
    label="Users"
    value="67.4k"></vex-widget-quick-value-center>
  <vex-widget-quick-value-center
    [change]="-23.7"
    helpText="Additional information"
    icon="mat:pageview"
    iconClass="text-orange-600 bg-orange-600/10"
    label="Sessions"
    value="96.2k"></vex-widget-quick-value-center>
  <vex-widget-quick-value-center
    [change]="23.2"
    helpText="Explain something"
    icon="mat:cloud_off"
    iconClass="text-orange-600 bg-orange-600/10"
    label="Bounce Rate"
    value="6.92%"></vex-widget-quick-value-center>
  <vex-widget-quick-value-center
    [change]="34.5"
    icon="mat:timer"
    iconClass="text-teal-600 bg-teal/10"
    label="Session Duration"
    value="16m 48s"></vex-widget-quick-value-center>

  <vex-widget-large-chart
    [series]="userSessionsSeries"
    class="sm:col-span-2"></vex-widget-large-chart>

  <vex-widget-table
    [columns]="tableColumns"
    [data]="tableData"
    class="sm:col-span-2"></vex-widget-table>
</div>
